<template>
  <div class="tw-flex tw-justify-between">
    <WdsAvatarLabel
      class="tw-my-3 tw-ml-4"
      :path="getAvatarPath(avatarPath, globalId)"
      :initials="initials"
      :text="name"
      :text-link="link"
    >
      <template #avatar-wrapper>
        <ProfileInfoCard :global-id="globalId" placement="bottom" />
      </template>
    </WdsAvatarLabel>
    <FeatureFlagged name="ai-conversation-chat">
      <div v-if="context.aiConsent && context.threadId !== null" class="tw-my-3.5 tw-mr-4">
        <AiChat :context="context">
          Assistant
          <WdsLabel xs warning subtle>{{ $t('Beta') }}</WdsLabel>
        </AiChat>
      </div>
    </FeatureFlagged>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { WdsAvatarLabel, WdsLabel } from '@worksome/wds-components'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { getAvatarPath } from '@/utils/avatar'
import AiChat from '@/components/LLM/AiChat.vue'
import FeatureFlagged from '@/components/FeatureFlagged.vue'

const props = defineProps({
  userId: {
    type: Number,
    default: null,
  },

  threadId: {
    type: Number,
    default: null,
  },

  globalId: {
    type: String,
    default: null,
  },

  initials: {
    type: String,
    default: null,
  },

  avatarPath: {
    type: String,
    default: null,
  },

  name: {
    type: String,
    default: null,
  },

  link: {
    type: String,
    default: null,
  },

  aiThreadUuid: {
    type: String,
    default: null,
  },

  aiConsent: {
    type: Boolean,
    default: false,
  },
})

const context = {
  type: 'Dialog',
  id: props.threadId,
  aiConsent: props.aiConsent,
  aiThreadUuid: props.aiThreadUuid,
}
</script>
